<div *ngIf="commonSegmentFilters">
    <app-add-segment-popup-filter-row
        [template]="commonSegmentFilters"
        [dynamicFilters]="commonSegmentFilters.dynamicFilters"
    >
    </app-add-segment-popup-filter-row>
</div>

<div *ngFor="let oneTimeFilter of oneTimeFilters">
    <app-add-segment-popup-filter-row
        [template]="oneTimeFilter"
        [dynamicFilters]="oneTimeFilter.dynamicFilters"
    >
    </app-add-segment-popup-filter-row>
</div>
<div
    *ngIf="canAddRow"
    class="level-left padding-75-em"
>
    <app-button
        [buttonText]="'Add Row'"
        (buttonClick)="addRowOneTime()"
        [type]="'stroked'"
    />
</div>

<div class="level is-full-width button-row button-container">
    <div class="level-left">
        <app-filter-input
            *ngIf="!this.rowData?.isPolitical"
            [property]="this.addToPolitical"
        ></app-filter-input>
        <app-filter-input
            *ngIf="!this.rowData?.isDynamic"
            [property]="this.addToDynamic"
        ></app-filter-input>
    </div>
    <div class="level-right">
        <button
            mat-stroked-button
            class="button level-item is-danger popup-button"
            (click)="close()"
        >
            Cancel
        </button>
        <app-button
            [class]="'level-item popup-button'"
            [buttonText]="'Save'"
            (buttonClick)="save()"
            [type]="'flat'"
        />
    </div>
</div>
